import Message from "../../message";
import {useMainStore} from "@/store";
import EchoManager from "@/services/echo-manager";

export default class GuildDisbanded extends Message
{
    handle()
    {
        EchoManager.unsubscribeChannel('guild');
        useMainStore().SET_GUILD(null);
    }
}
